import tunnel from 'tunnel-rat';

// Lets HomeScreen put its gear in the app header, next to the chat-mode dropdown,
// without the header having to know which route is mounted
export const homeSettingsTunnel = tunnel();
